import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ArrowRight, Calendar } from 'lucide-react';
import './CallToAction.css';

const CallToAction = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="cta-section" ref={ref} data-testid="cta-section">
      <div className="container">
        <motion.div
          className="cta-content"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h2 className="cta-title" data-testid="cta-title">
            Let AI Work While You Scale
          </h2>
          <p className="cta-subtitle" data-testid="cta-subtitle">
            Ready to transform your business with AI?
          </p>
          <div className="cta-buttons">
            <motion.button
              className="btn-primary cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              data-testid="cta-consultation"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              <Calendar size={20} style={{ marginRight: '8px' }} />
              Schedule a Free Consultation
            </motion.button>
            <motion.button
              className="btn-secondary cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              data-testid="cta-custom-solution"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              Get Custom AI Solution
              <ArrowRight size={20} style={{ marginLeft: '8px' }} />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;
